import { Pie, PieChart } from 'recharts'
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '~/components/ui/chart'

export interface AppPieChartProps {
  data: { label: string; value: number; fill: string }[]
}

export const AppPieChart = ({ data }: AppPieChartProps) => {
  const chartConfig = Object.fromEntries(
    data.map((item) => [item.label, { label: item.label, color: item.fill }]),
  )

  return (
    <div className="flex justify-between aspect-video">
      <ChartContainer
        config={chartConfig}
        initialDimension={{ width: 200, height: 200 }}
        aspect="square"
      >
        <PieChart accessibilityLayer className="flex items-center justify-between">
          <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />

          <Pie data={data} dataKey="value" nameKey="label" innerRadius={50} />
        </PieChart>
      </ChartContainer>

      <div className="flex flex-col h-full justify-center gap-1">
        {data.map((item) => (
          <div className="flex gap-4 justify-between  w-full">
            <span style={{ color: item.fill }}>{item.label}</span>
            <span className="font-semibold">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
